import { useRef } from 'react';
import { useImmer } from 'use-immer';

export const initPasteBoardSelected = {
    ['pasteBoard0']: false,
    ['pasteBoard1']: false,
    ['pasteBoard2']: false,
};

const useCaseSupportingFileInputFunc = ({
    setCaseSupportingImgs,
    resetCaseSupportingImgs,
    removeCaseSupportingImgs,
}) => {
    const fileInputRef0 = useRef(null);
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);

    const [pasteBoardSelected, setPasteBoardSelected] = useImmer(initPasteBoardSelected);

    const assignRef = (index) => {
        if (index === 0) {
            return fileInputRef0;
        } else if (index === 1) {
            return fileInputRef1;
        } else if (index === 2) {
            return fileInputRef2;
        }
    };

    const resetPasteBoard = () => {
        setPasteBoardSelected(initPasteBoardSelected);
    };

    const handleSelectPasteBoard = (index = 0) => {
        resetPasteBoard();
        if (pasteBoardSelected[`pasteBoard${index}`] === false) {
            setPasteBoardSelected((draft) => {
                draft[`pasteBoard${index}`] = !draft[`pasteBoard${index}`];
            });
        }
    };

    const handleFileInput = (file, index) => {
        setCaseSupportingImgs(file, index);
    };

    const handlePaste = (e, index) => {
        const clipboardItems = e.clipboardData.items;
        let hasImg = false;
        for (let i = 0; i < clipboardItems.length; i++) {
            const item = clipboardItems[i];
            if (item.type.startsWith('image/')) {
                const file = item.getAsFile();
                if (file) {
                    hasImg = true;
                    handleFileInput(file, index);
                }
            }
        }
        if (!hasImg) {
            alert('No image found, please copy an image to paste.');
        }
    };

    const handleRemoveImg = (index) => {
        removeCaseSupportingImgs(index);
        setPasteBoardSelected((draft) => {
            draft[`pasteBoard${index}`] = false;
        });
    };

    const handleRemoveAllImgs = () => {
        resetCaseSupportingImgs();
        setPasteBoardSelected(initPasteBoardSelected);
    };

    return {
        assignRef,
        handleSelectPasteBoard,
        resetPasteBoard,
        setPasteBoardSelected,
        pasteBoardSelected,
        handleFileInput,
        handlePaste,
        handleRemoveImg,
        handleRemoveAllImgs,
    };
};

export default useCaseSupportingFileInputFunc;
